/*
 * Geração de payload PIX estático no padrão BR Code.
 *
 * Este código NÃO confirma pagamentos.
 * Ele apenas monta o Pix Copia e Cola que aponta
 * diretamente para a chave PIX da empresa.
 */

function emvField(
  id: string,
  value: string,
) {
  const length = new TextEncoder().encode(
    value,
  ).length;

  return (
    id +
    String(length).padStart(2, "0") +
    value
  );
}

function normalizePixText(
  value: string,
  maxLength: number,
) {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9 .\-]/g, "")
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase()
    .slice(0, maxLength);
}

function crc16Ccitt(
  value: string,
) {
  const bytes =
    new TextEncoder().encode(value);

  let crc = 0xffff;

  for (const byte of bytes) {
    crc ^= byte << 8;

    for (let bit = 0; bit < 8; bit += 1) {
      crc =
        crc & 0x8000
          ? ((crc << 1) ^ 0x1021) & 0xffff
          : (crc << 1) & 0xffff;
    }
  }

  return crc
    .toString(16)
    .toUpperCase()
    .padStart(4, "0");
}

function normalizeTxid(
  value: string,
) {
  const normalized = value
    .replace(/[^A-Za-z0-9]/g, "")
    .toUpperCase()
    .slice(0, 25);

  return normalized || "***";
}

export function buildPixPayload({
  pixKey,
  merchantName,
  merchantCity,
  amount,
  txid,
}: {
  pixKey: string;
  merchantName: string;
  merchantCity: string;
  amount: string | number;
  txid: string;
}) {
  const key = pixKey.trim();

  if (!key) {
    throw new Error(
      "Chave PIX não informada.",
    );
  }

  const name = normalizePixText(
    merchantName,
    25,
  );

  const city = normalizePixText(
    merchantCity,
    15,
  );

  if (!name) {
    throw new Error(
      "Nome do recebedor não informado.",
    );
  }

  if (!city) {
    throw new Error(
      "Cidade do recebedor não informada.",
    );
  }

  const numericAmount = Number(amount);

  if (
    !Number.isFinite(numericAmount) ||
    numericAmount <= 0
  ) {
    throw new Error(
      "Valor do PIX inválido.",
    );
  }

  const merchantAccountInformation =
    emvField(
      "00",
      "BR.GOV.BCB.PIX",
    ) +
    emvField(
      "01",
      key,
    );

  const additionalData =
    emvField(
      "05",
      normalizeTxid(txid),
    );

  const payloadWithoutCrc =
    emvField("00", "01") +
    emvField(
      "26",
      merchantAccountInformation,
    ) +
    emvField("52", "0000") +
    emvField("53", "986") +
    emvField(
      "54",
      numericAmount.toFixed(2),
    ) +
    emvField("58", "BR") +
    emvField("59", name) +
    emvField("60", city) +
    emvField(
      "62",
      additionalData,
    ) +
    "6304";

  return (
    payloadWithoutCrc +
    crc16Ccitt(payloadWithoutCrc)
  );
}
